/* 
Author:Lamiaa Moustafa
Desc: Landing page UI
*/

import React from 'react'
import { Outlet } from 'react-router-dom';
import { BackgroundImage } from '../../Styles/styledComponents/BgImage';
import { Logo } from "../../components/logo1st2911";
import { Footer1st2911 } from '../../components/Footer1st2911';

 const Landing = () => {
  return (
   <>
    <BackgroundImage>
      <Logo/>
      <Outlet />
    </BackgroundImage>
    <Footer1st2911/>
   </>
  )
}

export default Landing;


